module.exports = __webpack_public_path__ + "static/media/Data_insight_en_2-1.7c6064d5.svg";